/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum CustomerContactNotificationMethod {
    AutoEmail = 0,
    Phone = 1,
    Website = 2,
    Email = 3,
    WhatsApp = 4,
}
